import {
  put, call, takeLatest, fork, cancel, cancelled, race, delay, select
} from 'redux-saga/effects';
import {
  FETCH_DEVICES,
  CHECK_COMMUNICATION,
  SET_DEVICE_TIME_DETAILS,
  GET_DEVICE_TIME_DETAILS,
  CHECK_NUMBER_LOGS,
  ERASE_LOGS,
  RESET_MQTT_EVENT,
  WELDPARAMS,
  LOCATION,
  PASSWORD_PROTECTION,
  UPDATE_DEVICE_OPERATION_STATUS,
  START_COMMUNICATION_POLLING,
  STOP_COMMUNICATION_POLLING,
  POLL_COMMUNICATION_STATUS,
  SET_POLLING_STATUS,
  UPDATE_POLLING_PROGRESS,
  // Get All Devices Actions
  GET_ALL_DEVICES,
  FETCH_PROJECT_LIST,
  FETCH_DEVICE_PROJECT_LIST,
  // Rename Pass Actions
  RENAME_PASS,
  // Firmware Update Polling Actions
  START_FIRMWARE_UPDATE_POLLING,
  STOP_FIRMWARE_UPDATE_POLLING
} from './types';
import { Notification } from '../../components/ui/custom-notification';
import {
  setDevices,
  setDevicesFailure,

  setCommunicationSuccess,
  setCommunicationFailure,
  setCommunicationResponseTime,
  startCommunicationTimer,
  setAllDevicesSuccess,
  setAllDevicesFailure,
  setDeviceTimeSuccess,
  setDeviceTimeFailure,
  setDeviceTimeSetSuccess,
  setDeviceTimeSetFailure,
  setLogsSuccess,
  setLogsFailure,
  setEraseLogsSuccess,
  setEraseLogsFailure,
  setResetMqttEventSuccess,
  setResetMqttEventFailure,
  setWeldParamsSuccess,
  setWeldParamsFailure,
  setLocationSuccess,
  setLocationFailure,
  setDeviceOperationStatusSuccess,
  setDeviceOperationStatusFailure,
  setProjectList,
  setProjectListFailure,
  setDeviceProjectList,
  setDeviceProjectListFailure,
  setRenamePassSuccess,
  setRenamePassFailure,
  updateFirmwareUpdateProgress,
  clearFirmwareUpdateProgress,
  removeFirmwareUpdateDevice,
  fetchDevices
} from './actions';
// import { deviceApi } from './deviceApi';
import get from 'lodash/get';
import { mockDevices } from '../../features/device/data/mockDevices';
import { transformDeviceFromApi, transformProjectFromApi } from '../../features/device/utils/deviceTransform';
import { resolveOperationForWeldUid } from '../../features/device/utils/deviceOperationResolve';
import axiosConfig from './axiosConfig';
import axios from 'axios';

const getStorageDeviceId = (payload) => payload.storageDeviceId || payload.deviceId;

// Polling configuration constants
const POLLING_CONFIG = {
  MAX_RETRIES: 15,
  RETRY_INTERVAL: 1000, // 1 second
  TIMEOUT: 60000, // 60 seconds total timeout
  WELD_PARAMS_MAX_RETRIES: 3600, // 60 minutes for weld parameter downloads
  WELD_PARAMS_RETRY_INTERVAL: 1000, // 1 second interval
  WELD_PARAMS_TIMEOUT: 3600000, // 60 minutes total timeout for weld parameters
  SUCCESS_STATUSES: 'Online',
  IN_PROGRESS_STATUS: 'In Progress'
};
// Polling utility function
const pollDeviceStatusAll = async (deviceId, maxRetries = POLLING_CONFIG.MAX_RETRIES, interval = POLLING_CONFIG.RETRY_INTERVAL, dispatch = null, type = 'CommCheck') => {
  let retryCount = 0;
  const startTime = Date.now();

  while (retryCount < maxRetries) {
    try {
      // Check if we've exceeded the total timeout
      if (Date.now() - startTime > POLLING_CONFIG.TIMEOUT) {
        return {
          success: false,
          status: 'Timeout',
          error: 'Polling timeout exceeded - device not responding',
          retryCount
        };
      }

      const url = `command/device/${deviceId}`;
      const response = await axiosConfig.get(url);

      if (response.status === 200) {
        const statusData = response.data.data;

        // Check if status is a success state based on command type
        let isSuccess = false;
        let isInProgress = false;

        if (type === 'GetTime') {
          // For GetTime command, check get_time.data
          isSuccess = statusData?.get_time?.data && statusData.get_time.data !== 'In Progress' && statusData.get_time.data !== '';
          isInProgress = statusData?.get_time?.data === 'In Progress';


        } if (type === 'NumOfLogs') {
          // For NumOfLogs command, check number_of_logs.data
          isSuccess = statusData?.number_of_logs?.data && statusData.number_of_logs.data !== 'In Progress' && statusData.number_of_logs.data !== '';
          isInProgress = statusData?.number_of_logs?.data === 'In Progress';
        }
        if (type === 'Location') {
          // For Location command, check location.data
          isSuccess = statusData?.location?.data && statusData.location.data !== 'In Progress' && statusData.location.data !== '';
          isInProgress = statusData?.location?.data === 'In Progress';
        }
        if (type === 'CommCheck') {
          // For other commands, check connection_status
          isSuccess = POLLING_CONFIG.SUCCESS_STATUSES === statusData.connection_status;
          isInProgress = statusData.connection_status === POLLING_CONFIG.IN_PROGRESS_STATUS;
        }

        // These yield statements were removed as they are not valid in a non-generator function

        // Check for errors that should stop polling
        let hasError = false;
        let errorMessage = '';

        if (type === 'GetTime' && statusData?.get_time?.error) {
          hasError = true;
          errorMessage = statusData.get_time.error;
        } else if (type === 'SetTime' && statusData?.set_time?.error) {
          hasError = true;
          errorMessage = statusData.set_time.error;
        } else if (type === 'NumOfLogs' && statusData?.number_of_logs?.error) {
          hasError = true;
          errorMessage = statusData.number_of_logs.error;
        } else if (type === 'EraseLogs' && statusData?.erase_logs?.error) {
          hasError = true;
          errorMessage = statusData.erase_logs.error;
        } else if (type === 'WeldParams' && statusData?.weld_parameter_logs?.error) {
          hasError = true;
          errorMessage = statusData.weld_parameter_logs.error;
        } else if (type === 'Location' && statusData?.location?.error) {
          hasError = true;
          errorMessage = statusData.location.error;
        }


        if (hasError) {
          // Stop polling and return error
          return {
            success: false,
            status: 'Error',
            data: statusData,
            error: errorMessage,
            retryCount: retryCount + 1
          };
        } else if (isSuccess) {
          let successStatus;
          if (type === 'GetTime') {
            successStatus = statusData.get_time.data;
          } else if (type === 'SetTime') {
            successStatus = statusData.set_time.data;
          } else if (type === 'NumOfLogs') {
            successStatus = statusData.number_of_logs.data;
          } else if (type === 'EraseLogs') {
            successStatus = statusData.erase_logs.data;
          } else if (type === 'WeldParams') {
            successStatus = statusData.weld_parameter_logs.data;
          } else if (type === 'Location') {
            successStatus = statusData.location.data;
          } else {
            successStatus = statusData.connection_status;
          }

          return {
            success: true,
            data: statusData,
            retryCount: retryCount + 1
          };
        } else if (isInProgress) {
          // Still in progress, wait and retry
          retryCount++;


          // Emit progress update to UI
          if (dispatch) {
            dispatch({
              type: UPDATE_POLLING_PROGRESS,
              payload: {
                deviceId,
                data: statusData,
                status: 'In Progress',
                retryCount,
                maxRetries,
                message: `Checking device status... (${retryCount}/${maxRetries})`
              }
            });
          }

          // Also emit custom event for real-time UI updates
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('pollingProgress', {
              detail: {
                deviceId,
                status: 'In Progress',
                retryCount,
                maxRetries,
                message: `Checking device status... (${retryCount}/${maxRetries})`
              }
            }));
          }

          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, interval));
            continue;
          } else {
            return {
              success: false,
              status: 'Timeout',
              data: statusData,
              error: 'Max retries reached while device is still not responding',
              retryCount
            };
          }
        } else {
          // Device is in an unknown or error state
          return {
            success: false,
            status: 'In Progress',
            data: statusData,
            error: `Device status: ${statusData.connection_status}`,
            retryCount: retryCount + 1
          };
        }
      }
    } catch (error) {
      retryCount++;

      if (retryCount >= maxRetries) {
        return {
          success: false,
          status: 'Timeout',
          error: `All polling attempts failed. Last error: ${error.message}`,
          retryCount
        };
      }

      // Wait before next retry
      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }

  return {
    success: false,
    status: 'Timeout',
    error: 'Max retries reached - device not responding',
    retryCount
  };
};

// Global polling state to prevent conflicts
const pollingState = {
  activePolling: new Set(),
  lastApiCall: 0,
  minIntervalBetweenCalls: 2000 // Minimum 2 seconds between any API calls
};

// Helper function to check if a device is being polled
const isDeviceBeingPolled = (deviceId) => {
  return pollingState.activePolling.has(deviceId);
};

// Helper function to get polling status
const getPollingStatus = () => {
  return {
    activeDevices: Array.from(pollingState.activePolling),
    lastApiCall: pollingState.lastApiCall,
    timeSinceLastCall: Date.now() - pollingState.lastApiCall
  };
};

// Dedicated polling function for weld parameter downloads
const pollWeldParameterDownload = async (deviceId, dispatch = null) => {
  // Check if already polling this device
  if (pollingState.activePolling.has(deviceId)) {
    console.log(`Already polling device ${deviceId}, skipping duplicate request`);
    return {
      success: false,
      status: 'AlreadyPolling',
      error: 'Device is already being polled',
      retryCount: 0
    };
  }

  // Add to active polling set
  pollingState.activePolling.add(deviceId);

  let retryCount = 0;
  const maxRetries = 480; // 40 minutes with 5-second intervals
  const interval = 5000; // 5 seconds - reduced frequency to avoid conflicts with other API calls
  const sameMessageTimeout = 2 * 60 * 1000; // 2 minutes

  let lastMessage = null;
  let sameMessageStartTime = null;
  let totalChunks = 0;
  let processedChunks = 0;
  let noProgressCount = 0;
  const maxNoProgressRetries = 10; // If no progress for 10 consecutive calls, increase interval

  while (retryCount < maxRetries) {
    try {
      // Check minimum interval between API calls
      const now = Date.now();
      const timeSinceLastCall = now - pollingState.lastApiCall;
      if (timeSinceLastCall < pollingState.minIntervalBetweenCalls) {
        const waitTime = pollingState.minIntervalBetweenCalls - timeSinceLastCall;
        //    console.log(`Waiting ${waitTime}ms before next API call to avoid conflicts`);
        await new Promise(resolve => setTimeout(resolve, waitTime));
      }

      const url = `command/device/${deviceId}`;
      pollingState.lastApiCall = Date.now();
      const response = await axiosConfig.get(url);

      if (response.status === 200) {
        const statusData = response.data.data;
        const weldParamData = statusData?.weld_parameter_logs?.data;

        if (!weldParamData) {
          retryCount++;
          await new Promise(resolve => setTimeout(resolve, interval));
          continue;
        }

        // Check if download is completed successfully
        if (weldParamData === 'Weld Parameter has been downloaded successfully') {
          pollingState.activePolling.delete(deviceId);
          return {
            success: true,
            data: statusData,
            retryCount: retryCount + 1,
            message: 'Download completed successfully'
          };
        }

        // Check if download is initiated
        // if (weldParamData === 'Weld Parameter Download is initiated, please check back later') 
        {
          // Same message - check if 60 seconds have passed
          if (lastMessage === weldParamData) {
            if (sameMessageStartTime && (Date.now() - sameMessageStartTime) >= sameMessageTimeout) {
              pollingState.activePolling.delete(deviceId);
              return {
                success: false,
                status: 'Failed',
                data: statusData,
                error: 'Weld parameter download failed - maximum time reached',
                retryCount
              };
            }
          } else {
            // Different message - reset timer
            lastMessage = weldParamData;
            sameMessageStartTime = Date.now();
          }

          if (deviceId && dispatch) {
            dispatch(setWeldParamsSuccess(deviceId, {
              data: {
                data: weldParamData,
                status: 'in_progress',
                message: weldParamData
              }
            }));
          }
        }

        // Check for chunk progress (e.g., "3 out of 40 chunks processed")
        const chunkMatch = weldParamData.match(/(\d+)\s+out\s+of\s+(\d+)\s+chunks\s+processed/);
        if (chunkMatch) {
          const newProcessedChunks = parseInt(chunkMatch[1]);
          const newTotalChunks = parseInt(chunkMatch[2]);

          //console.log('newProcessedChunks', newProcessedChunks > processedChunks);
          //console.log('newTotalChunks', newTotalChunks !== totalChunks);

          // Check if there's actual progress
          if (newProcessedChunks > processedChunks || newTotalChunks !== totalChunks) {
            processedChunks = newProcessedChunks;
            totalChunks = newTotalChunks;
            noProgressCount = 0; // Reset no progress counter
            //console.log('progress updated', processedChunks, totalChunks);

            // Update progress
            //console.log('dispatch called', deviceId);
            if (dispatch) {
              dispatch(setWeldParamsSuccess(deviceId, {
                data: {
                  data: weldParamData,
                  status: 'in_progress',
                  message: weldParamData,
                  progress: {
                    processed: processedChunks,
                    total: totalChunks,
                    percentage: Math.round((processedChunks / totalChunks) * 100)
                  }
                }
              }));
            }

            // Check if all chunks are processed
            if (processedChunks >= totalChunks) {
              //console.log('all chunks are processed');
              // Wait a bit more to get the final success message
              await new Promise(resolve => setTimeout(resolve, interval));
              continue;
            } else {
              console.log('not all chunks are processed');
            }
          } else {
            // No progress detected
            noProgressCount++;
            console.log(`No progress detected for device ${deviceId}, count: ${noProgressCount}`);
          }

          retryCount++;

          // Increase interval if no progress for too long
          const currentInterval = noProgressCount > maxNoProgressRetries ? interval * 2 : interval;
          await new Promise(resolve => setTimeout(resolve, currentInterval));
          continue;
        }

        // Check for errors
        if (statusData?.weld_parameter_logs?.error) {
          pollingState.activePolling.delete(deviceId);
          return {
            success: false,
            status: 'Error',
            data: statusData,
            error: statusData.weld_parameter_logs.error,
            retryCount: retryCount + 1
          };
        }

        // Unknown status - continue polling
        retryCount++;
        await new Promise(resolve => setTimeout(resolve, interval));
      } else {
        retryCount++;
        await new Promise(resolve => setTimeout(resolve, interval));
      }

    } catch (error) {
      retryCount++;

      if (retryCount >= maxRetries) {
        pollingState.activePolling.delete(deviceId);
        return {
          success: false,
          status: 'Timeout',
          error: `All polling attempts failed. Last error: ${error.message}`,
          retryCount
        };
      }

      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }

  // Always remove from active polling set when done
  pollingState.activePolling.delete(deviceId);
  //console.log(`Stopped polling device ${deviceId}. Active polling devices:`, Array.from(pollingState.activePolling));

  return {
    success: false,
    status: 'Timeout',
    error: 'Max retries reached - weld parameter download not completed',
    retryCount
  };
};

// Polling utility function
const pollDeviceStatus = async (deviceId, maxRetries = POLLING_CONFIG.MAX_RETRIES, interval = POLLING_CONFIG.RETRY_INTERVAL, dispatch = null, type = 'CommCheck', weldUID = null) => {
  let retryCount = 0;
  const startTime = Date.now();
  let sameMessageStartTime = null; // Timer for tracking same message
  let lastMessage = null; // Track the last message received

  // Use extended timeout for weld parameter downloads
  const timeout = type === 'WeldParams' ? POLLING_CONFIG.WELD_PARAMS_TIMEOUT : POLLING_CONFIG.TIMEOUT;

  while (retryCount < maxRetries) {
    try {
      // Check if we've exceeded the total timeout
      if (Date.now() - startTime > timeout) {
        return {
          success: false,
          status: 'Timeout',
          error: `Polling timeout exceeded - device not responding (${type === 'WeldParams' ? '60 minutes' : '60 seconds'})`,
          retryCount
        };
      }

      const url = `command/device/${deviceId}`;
      const response = await axiosConfig.get(url);

      if (response.status === 200) {
        const statusData = response.data.data;

        // Check if status is a success state based on command type
        let isSuccess = false;
        let isInProgress = false;
        let welparaminitiated = false;
        let progressMessage = '';
        let retryCountWeldParam = 0;
        let resolvedOp = null;

        if (type === 'GetTime') {
          resolvedOp = resolveOperationForWeldUid(statusData?.get_time, weldUID);
          isSuccess = Boolean(resolvedOp.data && resolvedOp.data !== 'In Progress' && resolvedOp.data !== '');
          isInProgress = resolvedOp.inProgress || (!resolvedOp.found && Boolean(weldUID));
        } else if (type === 'SetTime') {
          resolvedOp = resolveOperationForWeldUid(statusData?.set_time, weldUID);
          isSuccess = Boolean(resolvedOp.data && resolvedOp.data !== 'In Progress' && resolvedOp.data !== '');
          isInProgress = resolvedOp.inProgress || (!resolvedOp.found && Boolean(weldUID));
        } else if (type === 'NumOfLogs') {
          resolvedOp = resolveOperationForWeldUid(statusData?.number_of_logs, weldUID);
          isSuccess = Boolean(resolvedOp.data && resolvedOp.data !== 'In Progress' && resolvedOp.data !== '');
          isInProgress = resolvedOp.inProgress || (!resolvedOp.found && Boolean(weldUID));
        } else if (type === 'EraseLogs') {
          resolvedOp = resolveOperationForWeldUid(statusData?.erase_logs, weldUID);
          isSuccess = Boolean(resolvedOp.data && resolvedOp.data !== 'In Progress' && resolvedOp.data !== '');
          isInProgress = resolvedOp.inProgress || (!resolvedOp.found && Boolean(weldUID));
        } else if (type === 'WeldParams') {
          // For WeldParams command, use dedicated polling function
          // This should not be called directly - use pollWeldParameterDownload instead
          isSuccess = false;
          isInProgress = false;
        }
        else if (type === 'Location') {
          resolvedOp = resolveOperationForWeldUid(statusData?.location, weldUID);
          isSuccess = Boolean(resolvedOp.data && resolvedOp.data !== 'In Progress' && resolvedOp.data !== '');
          isInProgress = resolvedOp.inProgress || (!resolvedOp.found && Boolean(weldUID));
        } else {
          // For other commands, check connection_status
          isSuccess = POLLING_CONFIG.SUCCESS_STATUSES === statusData.connection_status;
          isInProgress = statusData.connection_status === POLLING_CONFIG.IN_PROGRESS_STATUS;
        }



        // Check for errors that should stop polling (prefer per-Weld_UID error)
        let hasError = false;
        let errorMessage = '';

        if (type === 'GetTime' || type === 'SetTime' || type === 'NumOfLogs' || type === 'EraseLogs' || type === 'Location') {
          if (resolvedOp?.found && resolvedOp.error) {
            hasError = true;
            errorMessage = resolvedOp.error;
          }
        } else if (type === 'WeldParams' && statusData?.weld_parameter_logs?.error) {
          hasError = true;
          errorMessage = statusData.weld_parameter_logs.error;
        }


        if (hasError) {
          // Stop polling and return error
          return {
            success: false,
            status: 'Error',
            data: statusData,
            error: errorMessage,
            retryCount: retryCount + 1
          };
        } else if (isSuccess) {
          return {
            success: true,
            data: statusData,
            resolvedData: resolvedOp?.data,
            weldUID: weldUID || undefined,
            retryCount: retryCount + 1
          };
        } else if (isInProgress) {
          // Still in progress, wait and retry
          retryCount++;


          // Emit progress update to UI
          if (dispatch) {
            dispatch({
              type: UPDATE_POLLING_PROGRESS,
              payload: {
                deviceId,
                data: statusData,
                status: 'In Progress',
                retryCount,
                maxRetries,
                message: `Checking device status... (${retryCount}/${maxRetries})`
              }
            });
          }

          // Also emit custom event for real-time UI updates
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('pollingProgress', {
              detail: {
                deviceId,
                status: 'In Progress',
                retryCount,
                maxRetries,
                message: `Checking device status... (${retryCount}/${maxRetries})`
              }
            }));
          }

          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, interval));
            continue;
          } else {
            return {
              success: false,
              status: 'Timeout',
              data: statusData,
              error: 'Max retries reached while device is still not responding',
              retryCount
            };
          }
        } else {
          // Device is in an unknown or error state
          return {
            success: false,
            status: 'In Progress',
            data: statusData,
            error: `Device status: ${statusData.connection_status}`,
            retryCount: retryCount + 1
          };
        }
      }
    } catch (error) {
      retryCount++;

      if (retryCount >= maxRetries) {
        return {
          success: false,
          status: 'Timeout',
          error: `All polling attempts failed. Last error: ${error.message}`,
          retryCount
        };
      }

      // Wait before next retry
      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }

  return {
    success: false,
    status: 'Timeout',
    error: 'Max retries reached - device not responding',
    retryCount
  };
};

const api = {
  Get_All_Devices: async (payload) => {
    try {
      const { deviceId, command = 'CommCheck', usePolling = true, weldType, weldUID } = payload;

      // First, initiate the communication check
      const params = {
        Command: 'CommCheck',
        Edge_UID: deviceId,
      };

      const url = `/command/CommCheck`;
      const res = await axiosConfig.post(url, params);

      if (res.status === 200) {
        if (usePolling) {
          // Use polling mechanism to check status
          const pollingResult = await pollDeviceStatus(deviceId, POLLING_CONFIG.MAX_RETRIES, POLLING_CONFIG.RETRY_INTERVAL, null);

          if (pollingResult.success) {
            // If communication test is successful, send additional commands
            const commands = [];

            // Get Time command
            if (weldType && weldUID) {
              const timeParams = {
                Command: 'GetTime',
                Edge_UID: deviceId,
                Weld_Type: weldType,
                Weld_UID: weldUID,
              };
              commands.push({ type: 'GetTime', params: timeParams });
            }

            // Location command
            if (weldType && weldUID) {
              const locationParams = {
                Command: 'Location',
                Edge_UID: deviceId,
                Weld_Type: weldType,
                Weld_UID: weldUID,
              };
              commands.push({ type: 'Location', params: locationParams });
            }

            // Number of Logs command
            if (weldType && weldUID) {
              const logsParams = {
                Command: 'NumOfLogs',
                Edge_UID: deviceId,
                Weld_Type: weldType,
                Weld_UID: weldUID,
              };
              commands.push({ type: 'NumOfLogs', params: logsParams });
            }

            // Execute all commands
            const commandResults = {};
            for (const cmd of commands) {
              try {
                const cmdRes = await axiosConfig.post(`/command/${cmd.type}`, cmd.params);
                if (cmdRes.status === 200) {
                  // Poll for this specific command
                  const cmdPollingResult = await pollDeviceStatus(deviceId, POLLING_CONFIG.MAX_RETRIES, POLLING_CONFIG.RETRY_INTERVAL, null, cmd.type);
                  commandResults[cmd.type] = cmdPollingResult.success ? cmdPollingResult.data : null;
                }
              } catch (cmdError) {
                console.warn(`Command ${cmd.type} failed:`, cmdError);
                commandResults[cmd.type] = null;
              }
            }

            return {
              data: {
                communication: {
                  data: pollingResult.data,
                  status: 'Success',
                  pollingInfo: {
                    retryCount: pollingResult.retryCount,
                    method: 'polling'
                  }
                },
                commands: commandResults
              }
            };
          } else {
            return {
              data: {
                communication: {
                  status: 'Failed',
                  error: pollingResult.error,
                  pollingInfo: {
                    retryCount: pollingResult.retryCount,
                    method: 'polling'
                  }
                }
              }
            };
          }
        }
      }
    } catch (error) {
      throw error;
    }
  },


  fetchProjectList: async (payload) => {
    try {
      // Use the same endpoint as Project saga
      let url;
      // If projectId is provided, get specific project by ID
      if (payload?.projectId) {
        url = `project/getProjectById/${payload.projectId}`;
      }
      // If userId is provided (for user/viewer roles), filter projects by userId
      else if (payload?.userId) {
        url = `project/getAllProjects?userId=${payload.userId}`;
      }
      // For super_admin and admin, get all projects without filter
      else {
        url = `project/getAllProjects`;
      }

      const res = await axiosConfig.get(url);

      if (res.status === 200) {
        const data = get(res, ['data', 'data'], []);
        // The API returns an array directly, not nested in a 'projects' property
        const projectList = Array.isArray(data) ? data : (data.projects || []);
        

     //   console.log('projectList', projectList);
        if (projectList.length > 0) {
          // Transform API response to match frontend expected format
          const transformedProjects = projectList.map(project => transformProjectFromApi(project));

          return {
            data: {
              projects: transformedProjects
            }
          };
        } else {
          return {
            data: {
              projects: []
            }
          };
        }
      }

      return {
        data: {
          projects: []
        }
      };
    } catch (error) {
      console.error('Failed to fetch project list:', error);
      // Return empty array on error
      return {
        data: {
          projects: []
        }
      };
    }
  },

  fetchDeviceProjectList: async (payload) => {
    const res = await axiosConfig.post('/admin/project-list-devices', payload);
    const responseData = get(res, ['data', 'data'], {});
    const projectList = Array.isArray(responseData.deviceHistoryList)
      ? responseData.deviceHistoryList
      : Array.isArray(responseData.projectList)
      ? responseData.projectList
      : [];

    return {
      data: {
        projectList
      }
    };
  },

  fetchDevices: async (payload) => {
    try {
      // Check if any devices are being polled and add small delay to avoid conflicts
      const pollingStatus = getPollingStatus();
      if (pollingStatus.activeDevices.length > 0) {
        const timeSinceLastCall = pollingStatus.timeSinceLastCall;
        if (timeSinceLastCall < pollingState.minIntervalBetweenCalls) {
          const waitTime = pollingState.minIntervalBetweenCalls - timeSinceLastCall;
          console.log(`fetchDevices: Waiting ${waitTime}ms to avoid conflicts with active polling`);
          await new Promise(resolve => setTimeout(resolve, waitTime));
        }
      }

      const url = `/admin/devices`;
      pollingState.lastApiCall = Date.now();
      const res = await axiosConfig.get(url);

      if (res.status === 200) {
        const devicesData = get(res, ['data', 'data'], []);

        // Transform API response to match frontend expected format
        const transformedDevices = devicesData.deviceList.map(device => transformDeviceFromApi(device));

        return {
          data: {
            devices: transformedDevices
          }
        };
      }


    } catch (error) {
      // Fallback to mock data on error

    }
  },

  checkCommunication: async (payload, dispatch = null) => {
    try {
      const { deviceId, command = 'CommCheck', usePolling = false } = payload;
      const params = {
        Command: 'CommCheck',
        Edge_UID: deviceId,
      };

      // Direct communication check - use the response directly
      const url = `/command/CommCheck`;
      const res = await axiosConfig.post(url, params);

      if (res.status === 200) {
        // Handle the direct response structure as provided by the user
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data === 'Online') {
          //  Notification.success('Communication check successful', `Device responded in ${responseData.data.Response_Time}s`);
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          //  Notification.error('Communication check failed', responseData.message || 'Device not responding');
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Communication check failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        Notification.error('Communication check command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },


  getDeviceTime: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/GetTime`;
      const params = {
        Command: 'GetTime',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        // Handle the direct response structure
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data !== '') {
          //  Notification.success('Get time successful', `Device responded in ${responseData.data.Response_Time}s`);
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          // Notification.error('Get time failed', responseData.message || 'Device not responding');
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Get time failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        //  Notification.error('Get time command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }

    } catch (error) {
      throw error;
    }
  },

  setDeviceTime: async (payload, dispatch = null) => {
    try {
      const { deviceId, timeDetails, weldType, weldUID } = payload;
      const url = `/command/SetTime`;
      const params = {
        Command: 'SetTime',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
        New_Time: timeDetails.New_Time,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        // Handle the direct response structure
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data === 'Success') {
          //  Notification.success('Set time successful', `Device responded in ${responseData.data.Response_Time}s`);
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          // Notification.error('Set time failed', responseData.message || 'Device not responding');
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Set time failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        Notification.error('Set time command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },



  checkNumberLogs: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/NumOfLogs`;
      const params = {
        Command: 'NumOfLogs',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        // Handle the direct response structure
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data !== '') {
          //  Notification.success('Number of logs check successful', `Device responded in ${responseData.data.Response_Time}s - Found ${responseData.data.Data} logs`);
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          // Notification.error('Number of logs check failed', responseData.message || 'Device not responding');
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Number of logs check failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        Notification.error('Number of logs command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },

  eraseLogs: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/EraseLogs`;
      const params = {
        Command: 'EraseLogs',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        // Handle the direct response structure
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data === 'Success') {
          //  Notification.success('Erase logs successful', `Device responded in ${responseData.data.Response_Time}s`);
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          // Notification.error('Erase logs failed', responseData.message || 'Device not responding');
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Erase logs failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        Notification.error('Erase logs command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },

  resetMqttEvent: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/ResetEvent`;
      const params = {
        Command: 'ResetMQTTEvent',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        const responseData = res.data;

        if (responseData.success === 1 && responseData.data && responseData.data.Data === 'Success') {
          return {
            data: {
              data: responseData.data,
              status: 'Success',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        } else {
          return {
            data: {
              status: 'Timeout',
              data: responseData.data || null,
              error: responseData.message || 'Reset MQTT event failed',
              pollingInfo: {
                retryCount: 0,
                method: 'direct'
              }
            }
          };
        }
      } else {
        Notification.error('Reset MQTT command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },

  getWeldParams: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/WeldParameter`;
      const params = {
        Command: 'WeldParameter',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        Notification.success('Weld parameter download initiated', 'Please wait while the download progresses...');

        // Use dedicated polling function for weld parameter downloads
        const pollingResult = await pollWeldParameterDownload(deviceId, dispatch);

        if (pollingResult.success) {
          // Notification.success('Weld parameter download completed successfully', `Download finished after ${pollingResult.retryCount} checks`);
          return {
            data: {
              data: pollingResult.data?.weld_parameter_logs?.data || pollingResult.data?.data,
              status: 'Success',
              pollingInfo: {
                retryCount: pollingResult.retryCount,
                method: 'weld_params_polling'
              }
            }
          };
        } else {
          Notification.error('Weld parameter download failed', pollingResult.error || 'Download did not complete');
          return {
            data: {
              data: 'Failed',
              status: 'Failed',
              error: pollingResult.error || 'Weld parameter download failed',
              pollingInfo: {
                retryCount: pollingResult.retryCount,
                method: 'weld_params_polling'
              }
            }
          };
        }
      } else {
        Notification.error('Weld parameter download command failed', 'please try again');
        return {
          data: {
            status: 'Error',
            error: 'HTTP request failed',
            pollingInfo: {
              retryCount: 0,
              method: 'direct'
            }
          }
        };
      }
    } catch (error) {
      throw error;
    }
  },
  getLocation: async (payload, dispatch = null) => {
    try {
      const { deviceId, weldType, weldUID } = payload;
      const url = `/command/Location`;
      const usePolling = true;
      const params = {
        Command: 'Location',
        Edge_UID: deviceId,
        Weld_Type: weldType,
        Weld_UID: weldUID,
      };

      const res = await axiosConfig.post(url, params);
      if (res.status === 200) {
        Notification.success('Location check command sent successfully', 'waiting for device to respond');
        if (usePolling) {
          // Poll the same Weld_UID that was commanded
          const pollingResult = await pollDeviceStatus(
            deviceId,
            POLLING_CONFIG.MAX_RETRIES,
            POLLING_CONFIG.RETRY_INTERVAL,
            dispatch,
            'Location',
            weldUID
          );

          if (pollingResult.success) {
            // Prefer per-UID resolved data only when present; otherwise top-level (other weld types)
            const locationOp = pollingResult.data?.location;
            const perUidData =
              weldUID && locationOp?.by_weld_uid?.[weldUID]
                ? locationOp.by_weld_uid[weldUID].data
                : undefined;
            const locationData =
              pollingResult.resolvedData ??
              perUidData ??
              locationOp?.data ??
              pollingResult.data?.data;
            return {
              data: {
                data: locationData,
                status: 'Success',
                pollingInfo: {
                  retryCount: pollingResult.retryCount,
                  method: 'polling'
                }
              }
            };
          } else {
            return {
              data: {
                data: 'Timeout',
                status: 'Timeout',
                error: pollingResult.error || 'Maximum retries reached - device not responding',
                pollingInfo: {
                  retryCount: pollingResult.retryCount,
                  method: 'polling'
                }
              }
            };
          }
        }
      } else {
        Notification.error('Location check command failed', 'please try again');
      }
    } catch (error) {
      throw error;
    }
  },


  AssignProjecttoDevice: async (payload) => {

    console.log('AssignProjecttoDevice payload', payload);
    try {
      const url = `/admin/assign-project`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        Notification.success('Assign project to device command sent successfully', 'waiting for device to respond');
        console.log('AssignProjecttoDevice res', res);
        return {
          data: res.data
        };
      }
    } catch (error) {
      console.log('AssignProjecttoDevice error', error);
    }
  },


  updateDeviceStatus: async (payload) => {
    try {
      const url = `/admin/update-status`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        Notification.success('Update device status command sent successfully', 'waiting for device to respond');
        //   console.log('updateDeviceStatus res', res);
        return {
          data: res.data
        };
      }
    } catch (error) {
      console.log('update Device Status error', error);
    }
  },

  renamePass: async (payload) => {
    try {
      const url = `limits/rename-pass`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        //   Notification.success('Rename pass command sent successfully', 'waiting for device to respond');
        // console.log('renamePass res', res);
        return {
          data: res.data
        };
      }
    } catch (error) {
      console.log('renamePass error', error);
    }
  }
}

// Sagas
function* fetchDevicesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.fetchDevices, payload);

    // Ensure we have an array of devices
    const devices = response.data?.devices || [];

    yield put(setDevices(devices));
  } catch (error) {
    yield put(setDevicesFailure(error.message));
    Notification.error('Failed to fetch devices', error.message);
  }
}

// Get All Devices Saga - No notifications, test connection and send commands
function* getAllDevicesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.Get_All_Devices, payload);

    if (response.data) {
      yield put(setAllDevicesSuccess(payload.deviceId, response.data));
    }
  } catch (error) {
    yield put(setAllDevicesFailure(error.message));
  }
}

// Communication Check Saga
function* checkCommunicationSaga(action) {
  try {
    const { payload } = action;

    // Start the communication timer
    const startTime = Date.now();
    yield put(startCommunicationTimer(payload.deviceId));

    const response = yield call(api.checkCommunication, payload, put);

    // Handle polling response structure
    if (response.data) {
      const statusData = response.data;
      const pollingInfo = statusData.pollingInfo || {};

      // Check if communication was successful
      if (statusData.status === 'Success') {
        const communicationData = statusData;

        // Use Response_Time from the API response directly instead of calculating
        const responseTime = communicationData.data?.Response_Time;

        // Convert to milliseconds if the response time is in seconds
        const responseTimeMs = responseTime ? responseTime * 1000 : null;

        // Only update if we have a valid response time from the API
        if (responseTimeMs && responseTimeMs > 0 && responseTimeMs < 30000) {
          yield put(setCommunicationResponseTime(payload.deviceId, responseTimeMs));
        }

        yield put(setCommunicationSuccess(payload.deviceId, communicationData));
        Notification.success(`${payload.deviceId} communication check successful`);

      } else if (statusData.status === 'Timeout') {
        // Handle timeout
        yield put(setCommunicationFailure(statusData.error || 'Communication check timeout - device not responding'));
        Notification.error(`${payload.deviceId} communication check timeout`, statusData.error || 'Device not responding');

      } else if (statusData.connection_status === 'In Progress') {
        // Handle polling failure
        const errorMessage = statusData.error || 'Communication check failed';
        yield put(setCommunicationFailure(`${payload.deviceId} communication check failed`));

        const retryMessage = pollingInfo.retryCount > 0 ?
          ` after ${pollingInfo.retryCount} attempts` : '';
        Notification.error(`${payload.deviceId} communication check failed${retryMessage}`, errorMessage);

      } else {
        // Handle other statuses (In Progress, Offline, etc.)
        const statusMessage = `Device status: ${statusData.error}`;
        yield put(setCommunicationFailure(statusMessage));
        Notification.warning(`${payload.deviceId} communication check in progress`, statusMessage);
      }

    }
  } catch (error) {
    yield put(setCommunicationFailure(error.message));
    Notification.error('Communication check failed', error.message);
  }
}



function* getDeviceTimeDetailsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.getDeviceTime, payload);

    if (response.data) {
      const statusData = response.data;
      const pollingInfo = statusData.pollingInfo || {};

      if (statusData.status === 'Success') {
        const communicationData = statusData;
        yield put(setDeviceTimeSuccess(getStorageDeviceId(payload), communicationData));
        Notification.success(`${payload.deviceId} time retrieved successfully`);

      }

      else if (statusData.status === 'Timeout') {
        // Handle timeout
        yield put(setDeviceTimeFailure(statusData.error || 'Device time check timeout - device not responding'));
        Notification.error(`${payload.deviceId} time check`, statusData.error || 'Device not responding');

      } else if (statusData.error === 'In Progress') {
        // Handle polling failure
        const errorMessage = statusData.error || 'Device time check failed';
        yield put(setDeviceTimeFailure(errorMessage));

        const retryMessage = pollingInfo.retryCount > 0 ?
          ` after ${pollingInfo.retryCount} attempts` : '';
        Notification.error(`${payload.deviceId} time check failed${retryMessage}`, errorMessage);

      } else {


        // Handle other statuses (In Progress, Offline, etc.)
        const statusMessage = `Device status: ${statusData.error}`;
        yield put(setDeviceTimeFailure(statusMessage));
        Notification.warning(`${payload.deviceId} time check in progress`, statusMessage);
      }
    }


  } catch (error) {
    yield put(setDeviceTimeFailure(error.message));
    Notification.error('Failed to get device time', error.message);
  }
}
// Device Time Management Sagas
function* setDeviceTimeDetailsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.setDeviceTime, payload, put);

    if (response.data) {
      const statusData = response.data;

      if (statusData.status === 'Success') {
        yield put(setDeviceTimeSetSuccess(getStorageDeviceId(payload), statusData));
        Notification.success(`${payload.deviceId} time updated successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setDeviceTimeSetFailure(statusData.error || 'Set time timeout - device not responding'));
        Notification.error(`${payload.deviceId} set time timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setDeviceTimeSetFailure(statusData.error || 'Failed to set device time'));
        Notification.error(`${payload.deviceId} failed to set time`, statusData.error);
      }
    } else {
      yield put(setDeviceTimeSetFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to set time`, 'No response data received');
    }
  } catch (error) {
    yield put(setDeviceTimeSetFailure(error.message));
    Notification.error('Failed to set device time', error.message);
  }
}
// Device Logs Management Sagas
function* checkNumberLogsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.checkNumberLogs, payload, put);

    if (response.data) {
      const statusData = response.data;

      if (statusData.status === 'Success') {
        yield put(setLogsSuccess(getStorageDeviceId(payload), statusData));
        Notification.success(`${payload.deviceId} number of logs retrieved successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setLogsFailure(statusData.error || 'Check logs timeout - device not responding'));
        Notification.error(`${payload.deviceId} check logs timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setLogsFailure(statusData.error || 'Failed to check number of logs'));
        Notification.error(`${payload.deviceId} failed to check number of logs`, statusData.error);
      }
    } else {
      yield put(setLogsFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to check number of logs`, 'No response data received');
    }
  } catch (error) {
    yield put(setLogsFailure(error.message));
    Notification.error('Failed to check number of logs', error.message);
  }
}

function* eraseLogsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.eraseLogs, payload, put);

    if (response.data) {
      const statusData = response.data;

      if (statusData.status === 'Success') {
        yield put(setEraseLogsSuccess(getStorageDeviceId(payload), statusData));
        Notification.success(`${payload.deviceId} device logs erased successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setEraseLogsFailure(statusData.error || 'Erase logs timeout - device not responding'));
        Notification.error(`${payload.deviceId} erase logs timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setEraseLogsFailure(statusData.error || 'Failed to erase logs'));
        Notification.error(`${payload.deviceId} failed to erase logs`, statusData.error);
      }
    } else {
      yield put(setEraseLogsFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to erase logs`, 'No response data received');
    }
  } catch (error) {
    yield put(setEraseLogsFailure(error.message));
    Notification.error('Failed to erase logs', error.message);
  }
}

function* resetMqttEventSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.resetMqttEvent, payload, put);

    if (response.data) {
      const statusData = response.data;

      const storageId = getStorageDeviceId(payload);
      if (statusData.status === 'Success') {
        yield put(setResetMqttEventSuccess(storageId, statusData));
        Notification.success(`${payload.deviceId} MQTT reset successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setResetMqttEventFailure(statusData.error || 'Reset MQTT timeout - device not responding'));
        Notification.error(`${payload.deviceId} reset MQTT timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setResetMqttEventFailure(statusData.error || 'Failed to reset MQTT'));
        Notification.error(`${payload.deviceId} failed to reset MQTT`, statusData.error);
      }
    } else {
      yield put(setResetMqttEventFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to reset MQTT`, 'No response data received');
    }
  } catch (error) {
    yield put(setResetMqttEventFailure(error.message));
    Notification.error('Failed to reset MQTT', error.message);
  }
}

// Weld Parameters Saga
function* weldParamsSaga(action) {
  try {
    const { payload } = action;

    // Get store instance to access dispatch function
    const { getStore } = require('../store');
    const store = getStore();
    const dispatchFn = store ? store.dispatch : null;

    const response = yield call(api.getWeldParams, payload, dispatchFn);

    if (response.data) {
      const statusData = response.data;

      if (statusData.status === 'Success') {
        yield put(setWeldParamsSuccess(payload.deviceId, statusData));
        Notification.success(`${payload.deviceId} weld parameters retrieved successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setWeldParamsFailure(statusData.error || 'Weld params timeout - device not responding'));
        Notification.error(`${payload.deviceId} weld params timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setWeldParamsFailure(statusData.error || 'Failed to get weld parameters'));
        Notification.error(`${payload.deviceId} failed to get weld parameters`, statusData.error);
      }
    } else {
      yield put(setWeldParamsFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to get weld parameters`, 'No response data received');
    }
  } catch (error) {
    yield put(setWeldParamsFailure(error.message));
    Notification.error('Failed to get weld parameters', error.message);
  }
}

// Location and Password Protection Sagas (reusing weldParamsSaga)
function* fetchLocationSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.getLocation, payload, put);

    if (response.data) {
      const statusData = response.data;

      if (statusData.status === 'Success') {
        yield put(setLocationSuccess(getStorageDeviceId(payload), statusData));
        Notification.success(`${payload.deviceId} location retrieved successfully`);
      } else if (statusData.status === 'Timeout') {
        yield put(setLocationFailure(statusData.error || 'Location timeout - device not responding'));
        Notification.error(`${payload.deviceId} location check  timeout`, statusData.error || 'Device not responding');
      } else {
        yield put(setLocationFailure(statusData.error || 'Failed to fetch location'));
        Notification.error(`${payload.deviceId} failed to fetch location`, statusData.error);
      }
    } else {
      yield put(setLocationFailure('No response data received'));
      Notification.error(`${payload.deviceId} failed to fetch location`, 'No response data received');
    }
  } catch (error) {
    yield put(setLocationFailure(error.message));
    Notification.error('Failed to fetch location', error.message);
  }
}

// Device Operation Status Update Saga
function* updateDeviceOperationStatusSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.updateDeviceStatus, payload);

    if (response.data.success === 1) {
      yield put(setDeviceOperationStatusSuccess(
        response.data.deviceId,
        payload.operationStatus,
        payload.lastUpdated
      ));
      Notification.success(`${payload.deviceId} device operation status updated successfully`);
    } else {
      yield put(setDeviceOperationStatusFailure(response.data.message || 'Failed to update operation status'));
      Notification.error(`${payload.deviceId} failed to update operation status`, response.data.message);
    }
  } catch (error) {
    yield put(setDeviceOperationStatusFailure(error.message));
    Notification.error('Failed to update operation status', error.message);
  }
}

// Polling Management Sagas
function* startCommunicationPollingSaga(action) {
  try {
    const { payload } = action;
    const { deviceId, maxRetries, interval } = payload;

    // Dispatch polling status update
    yield put({
      type: SET_POLLING_STATUS,
      payload: {
        deviceId,
        isPolling: true,
        retryCount: 0,
        maxRetries: maxRetries || POLLING_CONFIG.MAX_RETRIES
      }
    });

    // Start the polling process
    const pollingResult = yield call(pollDeviceStatus, deviceId, maxRetries, interval);

    // Dispatch final polling status
    yield put({
      type: SET_POLLING_STATUS,
      payload: {
        deviceId,
        isPolling: false,
        retryCount: pollingResult.retryCount,
        success: pollingResult.success
      }
    });

    if (pollingResult.success) {
      yield put(setCommunicationSuccess(deviceId, {
        ...pollingResult.data,
        pollingInfo: {
          retryCount: pollingResult.retryCount,
          method: 'polling'
        }
      }));
    } else {
      yield put(setCommunicationFailure(pollingResult.error));
    }

  } catch (error) {
    yield put(setCommunicationFailure(error.message));
    yield put({
      type: SET_POLLING_STATUS,
      payload: {
        deviceId: action.payload.deviceId,
        isPolling: false,
        error: error.message
      }
    });
  }
}

function* stopCommunicationPollingSaga(action) {
  try {
    const { deviceId } = action.payload;

    yield put({
      type: SET_POLLING_STATUS,
      payload: {
        deviceId,
        isPolling: false,
        stopped: true
      }
    });

    Notification.info('Communication polling stopped');
  } catch (error) {
  }
}


function* Get_All_DevicesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.Get_All_Devices, payload);

    if (response.data) {
      yield put(setDevices(response.data));
    }

  } catch (error) {
    yield put(setDevicesFailure(error.message));
    Notification.error('Failed to get all devices', error.message);
  }
}

function* fetchProjectListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.fetchProjectList, payload);

    if (response.data && response.data.projects) {
      yield put(setProjectList(response.data.projects));
    }

  } catch (error) {
    yield put(setProjectListFailure(error.message));
    Notification.error('Failed to get project list', error.message);
  }
}

function* fetchDeviceProjectListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.fetchDeviceProjectList, payload);

    yield put(setDeviceProjectList(response.data?.projectList || []));
  } catch (error) {
    const errorMessage =
      (typeof error === 'string' ? error : null) ||
      error?.data?.message ||
      error?.data?.data?.message ||
      error?.message ||
      'Failed to get project list for selected device';
    yield put(setDeviceProjectListFailure(errorMessage));
    Notification.error('Failed to get selected device project list', errorMessage);
  }
}

function* renamePassSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(api.renamePass, payload);
    if (response.data) {
      yield put(setRenamePassSuccess(payload.project_id || payload.job_number, response.data));
      Notification.success(`Pass renamed successfully`);
    } else {
      yield put(setRenamePassFailure(response.data.error || 'Failed to rename pass'));
      Notification.error(`Failed to rename pass`, response.data.error);
    }
  } catch (error) {
    yield put(setRenamePassFailure(error.message));
    Notification.error('Failed to rename pass', error.message);
  }
}

// Firmware Update Polling Saga
const activePollingTasks = {};

function* pollFirmwareStatus(deviceId, deviceData) {
  try {
    const POLL_INTERVAL = 5000; // 5 seconds
    const MAX_POLL_ATTEMPTS = 60; // 5 minutes max (60 * 5 seconds)
    let pollCount = 0;

    while (pollCount < MAX_POLL_ATTEMPTS) {
      try {
        const deviceDataResponse = yield call(getStatusOfFirmwareUpdate, deviceId);
        
        if (deviceDataResponse) {
          const firmwareUpdate = deviceDataResponse?.firmware_update;
          
          if (firmwareUpdate) {
            const firmwareUpdateStatus = firmwareUpdate.data;
            const firmwareUpdateError = firmwareUpdate.error;
            const statusLower = firmwareUpdateStatus ? String(firmwareUpdateStatus).toLowerCase().trim() : '';
            const hasError = firmwareUpdateError && String(firmwareUpdateError).trim() !== '';
            
            // Update progress in Redux
            yield put(updateFirmwareUpdateProgress(deviceId, {
              status: statusLower || 'initiated',
              error: hasError ? String(firmwareUpdateError).trim() : null,
              lastUpdate: new Date().toISOString()
            }));
            
            // Handle different statuses
            if (statusLower === 'success' || statusLower === 'completed') {
              // Fetch fresh device data to get updated EdgeFWVersion
              const freshDeviceData = yield call(getStatusOfFirmwareUpdate, deviceId);
              const currentEdgeFWVersion = freshDeviceData?.EdgeFWVersion;
              
              // Check if EdgeFWVersion is "-" which means device is still reporting/updating
              if (currentEdgeFWVersion === '-') {
                // Device is still reporting - continue polling
                yield put(updateFirmwareUpdateProgress(deviceId, {
                  status: 'in_progress',
                  error: null,
                  firmwareVersion: currentEdgeFWVersion
                }));
                
                // Continue polling - don't return, let the loop continue
              } else if (currentEdgeFWVersion && currentEdgeFWVersion.trim() !== '') {
                // EdgeFWVersion is available and not "-" - firmware update successful
                yield put(updateFirmwareUpdateProgress(deviceId, {
                  status: 'completed',
                  error: null,
                  firmwareVersion: currentEdgeFWVersion
                }));
                
                // Remove from Redux tracking
                yield put(removeFirmwareUpdateDevice(deviceId));
                
                // Show success notification
                Notification.success('Firmware Update Successful', 'Firmware has been updated successfully on the device.');
                
                // Refresh device data
                yield put(fetchDevices({}));
                
                // Don't clear progress automatically - let user dismiss manually
                // Progress will remain visible until user closes it
                
                return; // Exit polling
              } else {
                // EdgeFWVersion is empty/null - continue polling to wait for version
                yield put(updateFirmwareUpdateProgress(deviceId, {
                  status: 'in_progress',
                  error: null,
                  firmwareVersion: null
                }));
                
                // Continue polling - don't return, let the loop continue
              }
            } else if (statusLower === 'failed' || statusLower === 'error' || hasError) {
              // Firmware update failed
              const errorMsg = hasError ? String(firmwareUpdateError).trim() : 'Firmware update failed';
              
              yield put(updateFirmwareUpdateProgress(deviceId, {
                status: 'failed',
                error: errorMsg
              }));
              
              // Remove from Redux tracking
              yield put(removeFirmwareUpdateDevice(deviceId));
              
              // Show error notification
              Notification.error('Firmware Update Failed', errorMsg);
              
              // Don't clear progress automatically - let user dismiss manually
              // Progress will remain visible until user closes it
              
              return; // Exit polling
            } else if (statusLower === 'initiated') {
              // Still in progress, continue polling
              yield put(updateFirmwareUpdateProgress(deviceId, {
                status: 'in_progress'
              }));
            }
          }
        }
        
        pollCount++;
        yield delay(POLL_INTERVAL);
      } catch (error) {
        console.error('Error polling firmware status:', error);
        // Continue polling on error (might be temporary network issue)
        pollCount++;
        yield delay(POLL_INTERVAL);
      }
    }
    
    // Max attempts reached - stop polling
    yield put(updateFirmwareUpdateProgress(deviceId, {
      status: 'timeout',
      error: 'Firmware update polling timeout - maximum attempts reached'
    }));
    yield put(removeFirmwareUpdateDevice(deviceId));
  } catch (error) {
    console.error('Firmware polling saga error:', error);
    yield put(updateFirmwareUpdateProgress(deviceId, {
      status: 'error',
      error: error.message
    }));
  } finally {
    if (yield cancelled()) {
      // Cleanup if cancelled
      delete activePollingTasks[deviceId];
    }
  }
}

function* startFirmwareUpdatePollingSaga(action) {
  const { deviceId, deviceData } = action;
  
  // Cancel existing polling for this device if any
  if (activePollingTasks[deviceId]) {
    yield cancel(activePollingTasks[deviceId]);
  }
  
  // Start new polling task
  const task = yield fork(pollFirmwareStatus, deviceId, deviceData);
  activePollingTasks[deviceId] = task;
}

function* stopFirmwareUpdatePollingSaga(action) {
  const { deviceId } = action;
  
  if (activePollingTasks[deviceId]) {
    yield cancel(activePollingTasks[deviceId]);
    delete activePollingTasks[deviceId];
  }
}

// Root saga
export default function* deviceSaga() {
  yield takeLatest(FETCH_DEVICES, fetchDevicesSaga);
  yield takeLatest(GET_ALL_DEVICES, getAllDevicesSaga);
  yield takeLatest(CHECK_COMMUNICATION, checkCommunicationSaga);
  yield takeLatest(SET_DEVICE_TIME_DETAILS, setDeviceTimeDetailsSaga);
  yield takeLatest(GET_DEVICE_TIME_DETAILS, getDeviceTimeDetailsSaga);
  yield takeLatest(CHECK_NUMBER_LOGS, checkNumberLogsSaga);
  yield takeLatest(ERASE_LOGS, eraseLogsSaga);
  yield takeLatest(RESET_MQTT_EVENT, resetMqttEventSaga);
  yield takeLatest(WELDPARAMS, weldParamsSaga);
  yield takeLatest(LOCATION, fetchLocationSaga);
  //yield takeLatest(PASSWORD_PROTECTION, fetchPasswordProtectionSaga);
  yield takeLatest(UPDATE_DEVICE_OPERATION_STATUS, updateDeviceOperationStatusSaga);
  yield takeLatest(START_COMMUNICATION_POLLING, startCommunicationPollingSaga);
  yield takeLatest(STOP_COMMUNICATION_POLLING, stopCommunicationPollingSaga);
  yield takeLatest(FETCH_PROJECT_LIST, fetchProjectListSaga);
  yield takeLatest(FETCH_DEVICE_PROJECT_LIST, fetchDeviceProjectListSaga);
  yield takeLatest(RENAME_PASS, renamePassSaga);
  yield takeLatest(START_FIRMWARE_UPDATE_POLLING, startFirmwareUpdatePollingSaga);
  yield takeLatest(STOP_FIRMWARE_UPDATE_POLLING, stopFirmwareUpdatePollingSaga);

}



export const updateDeviceStatus = async (payload) => {
  try {
    const url = `/admin/update-status`;
    const res = await axiosConfig.post(url, payload);

    if (res.status === 200) {
      Notification.success('Device status updated successfully');
    //  console.log('updateDeviceStatus res', res);
      return {
        data: res.data
      };
    }
  } catch (error) {
    console.log('update Device Status error', error);
  }
}


export const assignProjecttoDevice = async (payload) => {
  try {
    console.log('assignProjecttoDevice payload', payload);
    const url = `/admin/assign-project`;
    const res = await axiosConfig.post(url, payload);

    if (res.status === 200) {
      Notification.success('Device assigned to Project successfully');
   //   console.log('assignProjecttoDevice res', res);
      return {
        data: res.data
      };
    }
  } catch (error) {
    console.log('assign Project to Device error', error);
  }
}


// Function to upload single file to S3
export const getPreSignedUrlToUploadFirmware = async (fileList, payload, version = 1) => {
  try {
    if (!fileList || fileList.length === 0) {
      Notification.error('Upload Failed', 'No file selected.');
      return null;
    }

    // Get the first file (single file upload only)
    const file = fileList[0];

    // Create single file object
    const fileObj = {
      deviceType: payload.deviceType,
      connectionType: payload.connectionType,
      fileName: file.name,
      fileSize: file.size,
      contentType: file.type,
      processType: payload.processType
    };

    // Get presigned URL for single file
    const response = await axiosConfig.post(`command/upload-firmware`, fileObj);

    if (response.status === 200) {
   //   console.log('response', response);
      // Get single response object (not array)
      const presignedData = response.data.data;
    //  console.log('presignedData', presignedData);

      // Validate presigned URL data
      if (!presignedData || !presignedData.presignedUrl) {
        Notification.error('Upload Failed', 'Failed to get upload URL from server.');
        return null;
      }

      try {
        // Log the presigned URL (remove sensitive parts for security)
        const urlParts = presignedData.presignedUrl.split('?');
      //  console.log('data.publicUrl', presignedData.publicUrl);

        // Small delay to ensure URL is ready (optional)
        await new Promise(resolve => setTimeout(resolve, 100));

        // Upload file to S3
        const uploadResponse = await axios.put(presignedData.presignedUrl, file, {
          headers: {
            "Content-Type": file.type || "application/octet-stream",
          },
          // Add timeout to prevent hanging requests
         // timeout: 100000,
        });

        if (uploadResponse.status === 200) {
       //   console.log('uploadedFile', presignedData);
          // Return single object (not array)
          return presignedData;
        } else {
          Notification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
          return null;
        }
      } catch (error) {
        // Add more detailed error logging
        if (error.response) {
          console.error('Upload error response:', error.response);
        }
        // Show user-friendly error
        Notification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
        return null;
      }
    } else {
      Notification.error('Upload Failed', 'Failed to get upload URL from server.');
      return null;
    }
  } catch (error) {
    console.error('Firmware upload error:', error);
    Notification.error('Upload Failed', 'An error occurred while uploading the firmware file.');
    return null; // Return null on error
  }
};

export const updateFirmware = async (payload) => {
  try {
    const url = `command/FirmwareUpdate`;
    const res = await axiosConfig.post(url, payload);
    //console.log('updateFirmware res', res);
    if (res.status === 200) {
      // Notification is handled in the component
      return {
        data: res.data
      };
    }
  } catch (error) {
    console.log('update Firmware error', error);
    // Notification is handled in the component
    throw error;
  }
}

export const getStatusOfFirmwareUpdate = async (deviceId) => {
  try {
    const url = `command/device/${deviceId}`;
    const res = await axiosConfig.get(url);
    //  console.log('getStatusOfFirmwareUpdate res', res);
    if (res.status === 200) {
      // Notification is handled in the component

      return res.data.data;

    }
  } catch (error) {
    console.log('update Firmware error', error);
    // Notification is handled in the component
    return null;
  }
}




